import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { fireAndForget } from 'wfui-digital-core/es/lib';
import globals from '../globals/globals';
import rootContext from '../root-context/root-context';
export default (function (_ref) {
  var _url = _ref.url,
      _ref$includeRootConte = _ref.includeRootContext,
      includeRootContext = _ref$includeRootConte === void 0 ? true : _ref$includeRootConte,
      _ref$cache = _ref.cache,
      cache = _ref$cache === void 0 ? false : _ref$cache,
      options = _objectWithoutProperties(_ref, ["url", "includeRootContext", "cache"]);

  var url = (includeRootContext ? rootContext() : '') + _url; // Cache busting for IE11

  if (!cache) {
    options.params = Object.assign({}, options.params, {
      '_': new Date().getTime()
    });
  } // Define timeout


  options.timeout = options.timeout || globals().defaultTimeout || 30000;
  return fireAndForget({
    url: url,
    options: options
  });
});